<div class="detail-container">
  <div class="detail-wrapper" *ngIf="avoir && !isLoading">
    
    <!-- Top Header: Exactly Mirroring Popup Layout -->
    <header class="popup-mirror-header">
      <div class="header-left">
        <div class="header-icon-circle">
          <i class="fa fa-reply"></i>
        </div>
        <div class="header-info-group">
          <h2>Bilan de Remboursement</h2>
          <div class="sub-badges">
            <span class="badge-gray">Audit #{{ avoir.id }}</span>
            <span class="badge-gray">Source CMD #{{ avoir.originalOrderId }}</span>
            <span [class]="'status-badge ' + (avoir.status === 'APPROVED' ? 'bg-green-soft' : avoir.status === 'READY_TO_APPROVE' ? 'bg-blue-soft' : avoir.status === 'REJECTED' ? 'bg-red-soft' : 'bg-orange-soft')">
              {{ avoir.status === 'READY_TO_APPROVE' ? 'PRÊT À VALIDER' : (avoir.status || 'PENDING') }}
            </span>
          </div>
        </div>
      </div>
      
      <div class="header-actions no-print">
        <button (click)="goBack()" class="btn-back-minimal">
          <i class="fa fa-arrow-left"></i> Retour
        </button>

        <!-- Actions Three-Dot Menu -->
        <div class="actions-menu-container" *ngIf="avoir.status !== 'REJECTED'">
          <button (click)="toggleActionsMenu($event)" class="btn-icon-more" [class.active]="showActionsMenu">
            <i class="fa fa-ellipsis-v"></i>
          </button>
          
          <div class="actions-dropdown" *ngIf="showActionsMenu">
            <div class="dropdown-header">Actions Admin</div>
            
            <button *ngIf="avoir.status !== 'APPROVED' && avoir.status !== 'COMPLETED'" (click)="modifyAvoir()" class="dropdown-item">
              <i class="fa fa-edit text-blue-500"></i> Modifier l'Audit
            </button>
            
            <button *ngIf="avoir.status === 'READY_TO_APPROVE'" (click)="approveAvoir()" class="dropdown-item primary">
              <i class="fa fa-check-circle text-emerald-500"></i> Approuver Définitivement
            </button>
            
            <div class="dropdown-divider" *ngIf="avoir.status !== 'APPROVED' && avoir.status !== 'COMPLETED'"></div>
            
            <button *ngIf="avoir.status !== 'APPROVED' && avoir.status !== 'COMPLETED'" (click)="deleteAvoir()" class="dropdown-item danger">
              <i class="fa fa-trash text-red-500"></i> Annuler & Supprimer
            </button>
          </div>
        </div>
      </div>
    </header>

    <div class="popup-mirror-content">
      
      <!-- Info Section -->
      <div class="info-cards-grid">
        <div class="meta-card">
          <span class="label">Client Concerné</span>
          <span class="value">{{ avoir.originalOrder?.client?.nom || 'Client' }} {{ avoir.originalOrder?.client?.prenom || 'Divers' }}</span>
        </div>
        <div class="meta-card">
          <span class="label">Chronologie</span>
          <span class="value">{{ formatDate(avoir.avoirDate) }}</span>
          <div *ngIf="avoir.approvalDate" class="text-[10px] text-emerald-600 mt-1">
            <i class="fa fa-check-circle"></i> Approuvé le {{ formatDate(avoir.approvalDate) }}
          </div>
        </div>
        <div class="meta-card">
          <span class="label">Impact Financier</span>
          <span class="value text-emerald-600">+ {{ recoveredCapital | number:'1.2-2' }} MAD</span>
        </div>
      </div>

      <!-- Notes Section -->
      <div *ngIf="avoir.notes" class="mb-8 p-4 bg-slate-50 border border-slate-200 rounded-xl">
        <span class="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Notes & Justification</span>
        <p class="text-sm text-slate-600 italic">"{{ avoir.notes }}"</p>
      </div>

      <!-- Table Section -->
      <div class="table-container-popup">
        <table class="table-popup">
          <thead>
            <tr>
              <th>Article</th>
              <th class="text-center">Qté</th>
              <th class="text-center">État Audit</th>
              <th class="text-right">Prix Remb.</th>
              <th class="text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let line of avoir.avoirLines">
              <td>
                <div class="item-bold">{{ line.product?.name }}</div>
                <div class="text-[11px] text-slate-400">Ref: {{ line.product?.codeBare }}</div>
              </td>
              <td class="text-center font-bold">{{ line.quantityReturned }}</td>
              <td class="text-center">
                <span [class]="line.isDefective ? 'status-badge-popup bg-red-soft' : 'status-badge-popup bg-green-soft'">
                  {{ line.isDefective ? 'Défectueux' : 'Conforme' }}
                </span>
              </td>
              <td class="text-right">{{ line.refundSellingPrice | number:'1.2-2' }}</td>
              <td class="text-right font-bold text-red-600">
                {{ (line.quantityReturned * (line.refundSellingPrice || 0)) | number:'1.2-2' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Financial Breakdown Section (Dette vs Cash) -->
      <div class="financial-breakdown-grid" *ngIf="avoir.discountAdjustment! > 0 || avoir.amountAbsorbedFromDebt! > 0">
        <div class="financial-row sub">
          <span class="f-label">Total Articles (Brut)</span>
          <span class="f-value">{{ avoir.totalRefund | number:'1.2-2' }} MAD</span>
        </div>
        <div class="financial-row sub" *ngIf="avoir.discountAdjustment! > 0">
          <span class="f-label text-red-600">Ajustement Réduction (Annulé)</span>
          <span class="f-value text-red-600">- {{ avoir.discountAdjustment | number:'1.2-2' }} MAD</span>
        </div>
        <div class="financial-separator"></div>
        <div class="financial-row main">
          <span class="f-label">Valeur Net de l'Avoir</span>
          <span class="f-value">{{ (avoir.totalRefund! - avoir.discountAdjustment!) | number:'1.2-2' }} MAD</span>
        </div>
        <div class="financial-row highlight-blue" *ngIf="avoir.amountAbsorbedFromDebt! > 0">
          <span class="f-label">
            <i class="fa fa-handshake-o"></i> Dette Client Absorbée (Impayé)
          </span>
          <span class="f-value">{{ avoir.amountAbsorbedFromDebt | number:'1.2-2' }} MAD</span>
        </div>
        <div class="financial-row highlight-emerald" *ngIf="avoir.amountRefundedInCash! > 0">
          <span class="f-label">
            <i class="fa fa-money"></i> Remboursement Cash (Caisse)
          </span>
          <span class="f-value">{{ avoir.amountRefundedInCash | number:'1.2-2' }} MAD</span>
        </div>
      </div>

    </div>

    <!-- ── EXACT SUMMARY FOOTER GRADIENT ── -->
    <div class="summary-footer-popup">
      <div class="summary-amount-block">
        <span class="summary-label">MONTANT FINAL{{ (avoir.amountRefundedInCash! > 0 && avoir.amountAbsorbedFromDebt! > 0) ? ' (CASH)' : '' }}</span>
        <div class="summary-amount">
          <span class="amount-big">{{ avoir.amountRefundedInCash | number:'1.2-2' }}</span>
          <span class="amount-unit">MAD</span>
        </div>
      </div>

      <div class="detail-actions no-print">
        <button *ngIf="avoir.status === 'APPROVED' || avoir.status === 'COMPLETED'" (click)="printAvoir()" class="btn-action-premium btn-print">
          <i class="fa fa-print"></i> Imprimer le Bon
        </button>
      </div>
    </div>

  </div>

  <!-- Loading Overlay -->
  <div *ngIf="isLoading" class="flex flex-col items-center justify-center py-40">
    <div class="w-10 h-10 border-4 border-red-100 border-t-red-600 rounded-full animate-spin"></div>
    <p class="mt-4 text-[11px] font-bold text-slate-400 uppercase tracking-widest">Sychronisation...</p>
  </div>
  <!-- Custom Confirmation Dialog -->
  <app-confirmation-dialog
    [isVisible]="isConfirmVisible"
    [title]="confirmTitle"
    [message]="confirmMessage"
    [type]="confirmType"
    [confirmText]="confirmBtnText"
    (confirm)="handleConfirm()"
    (cancel)="handleCancel()"
    (close)="isConfirmVisible = false">
  </app-confirmation-dialog>
</div>
